export default __webpack_public_path__ + "static/media/report-white-icon.21862e32.svg";